export default "__VITE_ASSET__CPlTRqP7__"